export const TOUCHMOVE = "touchmove";
export const KEYDOWN = "keydown";
